



import { Component, Vue, Prop} from 'vue-property-decorator';
import * as Components from '@/tenant/components';
import * as Common from '@/tenant/common';

@Component
export default class AtcSegment extends Vue {
  @Prop({ default: '' }) public title: string;
  @Prop({ default: null }) public value?: any | Common.IMasterItem;
  @Prop({ default: false }) public required: boolean;
  @Prop({ default: null }) public editor: Components.IEditor;
  @Prop({ default: true }) public enabled: boolean;
  @Prop() public tooltip: string;
  @Prop({default:true}) public isDirectEditEnabled:boolean;
  public isEdit: boolean = true;
  public validator: Components.ControlValidator = null;

  public created() {
    if (this.editor != null) this.editor.addControl(this);
  }

  public destroyed(){
    if (this.editor != null) this.editor.removeControl(this);    
  }  

  public get internalValue(): string {
    return this.value;
  }

  public set internalValue(value: string) {
    this.$emit('update:value', value);
    this.$emit('changed');
  }
}
  
